import { REHYDRATE } from "redux-persist";
import AuthenticationActionTypes from "services/authentication/types";
import ContractActionTypes from "services/contract/types";
import AutomaticSystemsTypes from "./types";

const initialState = {
  automaticSystems: {
    data: [],
    loading: false,
  },
  automaticSystemsDetails: {},
};

const AutomaticSystemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...initialState,
      };
    case AuthenticationActionTypes.LOG_OUT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return initialState;
    case AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS:
      return {
        ...state,
        automaticSystems: {
          ...state.automaticSystems,
          data: action.data,
        },
      };
    case AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_DETAILS:
      return {
        ...state,
        automaticSystemsDetails: {
          ...state.automaticSystemsDetails,
          [action.id]: {
            ...(state.automaticSystemsDetails?.[action.id] ?? {}),
            data: action.data,
          },
        },
      };
    case AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_LOADING:
      return {
        ...state,
        automaticSystems: {
          ...state.automaticSystems,
          loading: action.loading,
        },
      };
    case AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_DETAILS_LOADING:
      return {
        ...state,
        automaticSystemsDetails: {
          ...state.automaticSystemsDetails,
          [action.id]: {
            ...(state.automaticSystemsDetails?.[action.id] ?? {}),
            loading: action.loading,
          },
        },
      };
    case AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_STATUS_LOADING:
      return {
        ...state,
        automaticSystemsDetails: {
          ...state.automaticSystemsDetails,
          [action.id]: {
            ...(state.automaticSystemsDetails?.[action.id] ?? {}),
            statusLoading: action.loading,
          },
        },
      };
    case AutomaticSystemsTypes.SET_AUTOMATIC_SYSTEMS_MODE_LOADING:
      return {
        ...state,
        automaticSystemsDetails: {
          ...state.automaticSystemsDetails,
          [action.id]: {
            ...(state.automaticSystemsDetails?.[action.id] ?? {}),
            modeLoading: action.loading,
          },
        },
      };
    default:
      return state;
  }
};

export default AutomaticSystemsReducer;
